import MessagingHelpers from "../chat/helpers";

window.collapsedState = {};

export default function DashboardSavedRenderer() {
  this.helpers = new MessagingHelpers();
  this.userId = parseInt(document.body.dataset.userId);

  this.refresh = (data) => {
    if (!$("#saved-messages-container").length) {
      return;
    }

    let text = "";
    data.forEach((group) => (text += this.renderGroup(group)));
    $("#saved-messages-container").html(text);
  };

  this.refreshCounter = (length) => {
    const wrapper = document.getElementById("saved-counter");
    if (length) {
      wrapper.innerHTML = `<span class="badge badge-info ml-2">${length}</span>`;
    } else {
      wrapper.innerHTML = null;
    }
  };

  this.renderGroup = (group) => {
    const shipmentId = group.shipment.id;

    const chatType = Object.keys(group.records)[0];

    return `
    <div class="card dashboard-messages-group ${
      window.collapsedState[shipmentId] && "collapsed"
    }" data-shipment-id="${shipmentId}">
      <div class="group-actions card-header bg-light py-2 d-flex align-items-center">
        <a class="mr-4" href="/admin/shipments/${shipmentId}/${chatType}">${
      group.shipment.title
    }</a>
        <span>Owner: <a href="/admin/users/${group.shipment.owner.id}" class="owner-link">${
      group.shipment.owner.full_name
    }</a></span>
      </div>
      <div class="card-body unread-chat">
        ${this.renderChats(group.records, shipmentId)}
      </div>
    </div>
    `;
  };

  this.renderChats = (chats, shipmentId) => {
    return Object.keys(chats)
      .map((key) => {
        let chatName = "Private Chat";
        switch (key) {
          case "private_chat":
            chatName = "Private Chat";
            break;
          case "public_chat":
            chatName = "Public Chat";
            break;
          case "agents_chat":
            chatName = "Agents Chat";
            break;
          case "internal_chat":
            chatName = "Internal Chat";
            break;
        }

        return `
      <div class="d-flex mb-1">
        <a href="/admin/shipments/${shipmentId}/${key}" class="btn btn-sm btn-outline-primary">${chatName}<span class="badge badge-danger ml-1">${
          chats[key].length
        }</span>
        </a>
      </div>
      <ul class="list-group mt-2">
        ${this.renderNotifications(chats[key])}
      </ul>
      `;
      })
      .join("<hr>");
  };

  this.renderNotifications = (comments) => {
    let text = "";
    comments.forEach((message, _i) => {
      text += this.renderNotification(message);
    });
    return text;
  };

  this.renderNotification = (comment) => {
    return `
      <li class="list-group-item dashboard-single-message saved">
        <div class="d-flex align-items-center">
        <a class="refresh save-message saved mr-2" href="/admin/chats/${
          comment.chat_id
        }/chat_comments/${comment.id}/toggle_save" data-remote="true" data-method="post">
          <svg class="bs" width="20px" height="20px" fill="currentColor">
            <use xlink:href="/icons/bootstrap-icons.svg#bookmark-fill" />
          </svg>
        </a>
        <div class="single-message-author">${comment.author.full_name} | ${
      comment.author.organization_name
    }
          <small class="ml-2">${comment.human_time} ago</small></div>
        </div>
        <p class="single-message-content">
          ${this.helpers.safeHtml(comment.content)}
        </p>
      </li>
    `;
  };
}
